// angular
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
// others
import { LandingPageService } from './landing-page.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppService } from '../../../app/app.service';
import { CoreService } from '../../../app/core/core.service';
import { KlenicoMeService } from '../me.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
    selector: 'me-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    providers: [LandingPageService]
})

export class MeLandingPageComponent implements OnInit, OnDestroy {
    data = {
        'landingPageHero' : {},
        'landingPageHowItWorks' : {},
        'landingPageMarquee' : {},
        'landingPageProof' : {},
        'landingPageData' : {},
        'landingPageQuote' : {},
        'landingPageImageText' : {},
        'therapistsSection' : {},
        'faqSection' : {},
        'landingPageText' : {}
    };
    subLanguage: Subscription;
    subFolder: Subscription;
    folder = 'core';
    url = 'lp';

    @ViewChild('modalChangeLanguage', {static: false}) modalChangeLanguage: ModalDirective;

    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public translate: TranslateService,
        public landingPageService: LandingPageService,
        public meService : KlenicoMeService,
        public route: ActivatedRoute,
        public router: Router,
        public http: HttpClient,
        private cdr: ChangeDetectorRef,
        @Inject('storyBlokToken') public storyBlokToken: string,
    ) {

    }

    ngOnInit() {
        this.meService.isLandingPage = true;
        this.getContent();
        this.subLanguage = this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });

        this.subFolder = this.appService.meClinicFolderChanged.subscribe(value => {
            if (value != '') {
                this.getContent();
            }
        });

        this.route.queryParams.subscribe(params => {
            if (params['token'] && params['token'] != '') {
                this.meService.checkVoucher(params['token']).subscribe(res => {
                    this.appService.setMeClinicVoucher(params['token']);
                    this.appService.setMeClinicId(res['clinic_id']);
                    this.appService.setMeClinicFolderViaClinicId(res['clinic_id']);
                    this.resetHeaderParams();
                },
                error => {
                    this.resetHeaderParams();
                })
            } else {
                if (!this.appService.getMeClinicFolder() && !this.appService.getMeClinicVoucher()) {
                    this.appService.setMeClinicFolder('core');
                    this.landingPageService.getCountry().subscribe(res => {
                        let country = res['country'].toLowerCase();
                        if (country === 'ch') {
                            this.showLanguageModal();
                        }
                    });
                }
            }

            if (params['platform'] && params['platform'] != '') {
                this.appService.setMeClinicFlatform(params['platform']);
            }
        });
    }

    resetHeaderParams() {
        this.router.navigate(['me'], {
            queryParams: {
              'token': null,
            }
        });
    }

    ngOnDestroy() {
        this.subLanguage.unsubscribe();
        this.subFolder.unsubscribe();
    }

    getContent() {

        this.appService.isLoading = true;
        Object.keys(this.data).forEach(key => {
            this.data[key] = {};
        });


        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content']['content'] ?? [];
            contents.forEach(block => {
                this.data[block.component] = block;
            });
            this.appService.isLoading = false;
        });
    }

    changeToSwitze() {
        this.appService.setMeClinicFolder('ch');
        let url = 'https://api.storyblok.com/v2/cdn/stories/ch/config/?token=' + this.storyBlokToken;
        this.http.get(url).subscribe(res => {
            if (res['story']) {
                this.appService.setMeClinicConfig(JSON.stringify(res['story']['content']));
                this.appService.setMeClinicId(res['story']['content']['clinicId']);
            }
        });

        this.closeLanguageModal();
    }

    closeLanguageModal() {
        this.modalChangeLanguage.hide();
        const elem = document.getElementById("modalChangeLanguage");
        elem.classList.remove('show-modal');
        const backdrops = document.getElementsByTagName('bs-modal-backdrop');
        if (backdrops.length) {
            for (var i = 0; i < backdrops.length; i++) {
                backdrops[i].remove();
            }
        }
    }

    showLanguageModal() {
        this.modalChangeLanguage.show();
        setTimeout(() => {
            const elem = document.getElementById("modalChangeLanguage");
            elem.classList.add('show-modal');
        }, 500);
    }
}

